export const isInputFocused = (): boolean =>
  document.activeElement instanceof HTMLElement &&
  ['INPUT', 'TEXTAREA'].includes(document.activeElement.nodeName);
